import React from 'react';
import PropTypes from 'prop-types';
import PopoutBase from './PopoutBase';

class Popout extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override PopoutBase */
    styleType: PropTypes.string,
    /** Orientation on where the Popout should open (left, right) */
    orientation: PropTypes.string,
    /** Container element - useful for pulling width/height from */
    container: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    /** Allow hover to trigger open */
    hoverable: PropTypes.bool,
    /** Trigger for the Popout */
    trigger: PropTypes.node.isRequired,
    /** Content to display when Popout triggered */
    content: PropTypes.node.isRequired,
    /** Default padding to be applied on Popout */
    padding: PropTypes.number,
    /** Use width from parent container for Popout content width */
    useContainerWidth: PropTypes.bool,
    /** Reference callback to toggleActive() to trigger manual close of Popout */
    triggerClose: PropTypes.func,
    /** Reference callback to toggleActive() to trigger manual close of Popout */
    triggerOpen: PropTypes.func,
    /** Callback fired when Popout is opened */
    onOpen: PropTypes.func,
    /** Callback fired when Popout is closed */
    onClosed: PropTypes.func,
  };

  static defaultProps = {
    styleType: 'default',
    orientation: 'left',
    padding: 8,
    hoverable: true,
    open: false,
  };

  getStyles = type => {
    switch (type) {
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <PopoutBase styles={styles} {...otherProps} />;
  }
}

export default Popout;
